import Gikam from '../../../core/gikam-core';

var currentEditor;

document.addEventListener('mousedown', () => {
    if (currentEditor) {
        currentEditor.invisible = true;
        currentEditor.validateResult = true;
        currentEditor = null;
    }
});

export default {
    functional: true,
    props: {
        options: Object,
        row: Object,
        rowIndex: Number,
        cellIndex: Number
    },
    inject: {
        grid: {
            default: null
        }
    },
    render(h, ctx) {
        let editor = (ctx.props.options.type || "text") + "Field";
        let options = ctx.props.options;
        return (
            <editor
                options={ctx.props.options}
                rowIndex={ctx.props.rowIndex}
                cellIndex={ctx.props.cellIndex}
                ref={ctx.props.rowIndex + "_" + ctx.props.cellIndex}
                propValue={Gikam.getFieldValue(
                    ctx.props.row,
                    ctx.props.options.field
                )}
                propReadonly={
                    options.onEditorInitReadonly
                        ? options.onEditorInitReadonly(ctx.props.row)
                        : options.readonly
                }
                propInvisible={ctx.parent.editorInvisible}

                onChange={(...args) => {
                    Gikam.setFieldValue(
                        ctx.props.row,
                        args[0],
                        args[1]
                    );
                    if (
                        options.onChange &&
                        ctx.injections.grid.options.fieldChangeFlag
                    ) {
                        options.onChange.apply(
                            ctx.injections.grid,
                            args
                        );
                    }
                    if (ctx.injections.grid.canAutoSave) {
                        const data = { id: ctx.props.row.id, row: ctx.props.row };
                        data[args[0]] = args[1];
                        ctx.injections.grid.autoSave(data);
                    }
                }}

                onFocus={(...args) => {
                    if (!options.onFocus) {
                        return;
                    }
                    options.onFocus.apply(ctx.injections.grid, args);
                }}

                onAfterChoose={(...args) => {
                    if (!options.onAfterChoose) {
                        return;
                    }
                    options.onAfterChoose.apply(
                        ctx.injections.grid,
                        args
                    );
                }}

                onRendered={(...args) => {
                    if (!options.onRendered) {
                        return;
                    }
                    options.onRendered.apply(ctx.injections.grid, args);
                }}

                onKeydown={e => {
                    switch (e.keyCode) {
                        case 37:
                            e.preventDefault();
                            ctx.parent.inputCursorMovement(
                                ctx.props.rowIndex,
                                ctx.props.cellIndex - 1,
                                "left"
                            );
                            break;
                        case 38:
                            e.preventDefault();
                            ctx.parent.inputCursorMovement(
                                ctx.props.rowIndex - 1,
                                ctx.props.cellIndex,
                                "up"
                            );
                            break;
                        case 9:
                        case 39:
                            e.preventDefault();
                            ctx.parent.inputCursorMovement(
                                ctx.props.rowIndex,
                                ctx.props.cellIndex + 1,
                                "right"
                            );
                            break;
                        case 40:
                            e.preventDefault();
                            ctx.parent.inputCursorMovement(
                                ctx.props.rowIndex + 1,
                                ctx.props.cellIndex,
                                "down"
                            );
                            break;
                        case 13:
                            ctx.parent.inputCursorMovement(
                                ctx.props.rowIndex + 1,
                                ctx.props.cellIndex,
                                "down"
                            );
                            break;
                        default:
                            return;
                    }
                }}

                onClick={fieldEditor => {
                    //当前编辑器只读
                    if (fieldEditor.readonly) {
                        return;
                    }
                    //编辑器默认呈现样式
                    if (ctx.parent.editorInvisible === false) {
                        return;
                    }
                    //当前编辑器正在编辑中
                    if (currentEditor === fieldEditor) {
                        return;
                    }
                    if (currentEditor) {
                        //如果上一个编辑框校验不通过，则继续保持编辑状态
                        if (currentEditor.validateResult === false) {
                            return;
                        }
                        currentEditor.invisible = true;
                    }
                    fieldEditor.invisible = false;
                    currentEditor = fieldEditor;
                    fieldEditor.$nextTick(() => {
                        fieldEditor.focus && fieldEditor.focus();
                    });
                }}

            ></editor>
        );
    }
}